import API from 'services/api'
export default class Dashboard extends API {
	async getStatistics({
		onEnd = () => {},
		onError = () => {},
		onStart = () => {},
		onSuccess = () => {},
		filter,
	}) {
		onStart()
		const { month, year } = filter
		try {
			const options = {
				url: `/admin/statistics/${month ? `?month=${month}` : ''}${
					year ? `&year=${year}` : ''
				}`,
			}
			const response = await this.baseAPI(options)
			onSuccess(response)
		} catch (e) {
			onError(e)
		} finally {
			onEnd()
		}
	}
}
